const PAYMENT_TYPE = 'payment_type';
const PAYMENT_FORM_DATA = 'payment_form_data';
const PAYMENT_EMAIL = 'payment_email';
const PAYMENT_RECEIPT_DATA = 'payment_receipt_data';

class Storage {
  getPaymentType = () => {
    return sessionStorage.getItem(PAYMENT_TYPE);
  };

  savePaymentType = (type) => {
    return sessionStorage.setItem(PAYMENT_TYPE, type);
  };

  getPaymentFormData = () => {
    return this.getSessionCache(PAYMENT_FORM_DATA);
  };

  savePaymentFormData = (obj) => {
    return sessionStorage.setItem(PAYMENT_FORM_DATA, JSON.stringify(obj));
  };

  getPaymentEmail = () => {
    return localStorage.getItem(PAYMENT_EMAIL);
  };

  savePaymentEmail = (email) => {
    return localStorage.setItem(PAYMENT_EMAIL, email);
  };

  getPaymentReceiptData = () => this.getLocalCache(PAYMENT_RECEIPT_DATA);

  savePaymentReceiptData = (obj) =>
    localStorage.setItem(PAYMENT_RECEIPT_DATA, JSON.stringify(obj));

  getSessionCache = (key) => {
    let local = sessionStorage.getItem(key);
    return local === null ? undefined : JSON.parse(local);
  };

  getLocalCache = (key) => {
    let local = localStorage.getItem(key);
    return local === null ? undefined : JSON.parse(local);
  };
}

export default Storage;
